module.exports = __webpack_public_path__ + "assets/img/32_534_big.9eb894b2.jpg";